import { doc, setDoc, getDoc } from "firebase/firestore";
import React, {useState, useEffect} from "react";
import { db } from "@/firebaseConfig.js";

const fetchContent = async (collection, document) => {
    const docRef = doc(db, collection, document);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return docSnap.data().content || "";
    } else {
        console.log("Документ не найден!");
        return "";
    }
};

export default fetchContent;